import React from "react";

export default function PortionNotFound({ type }) {
  return <h4 className="home-loteamientos-emptyState">No se han encontrado {type} que coincidan con tu búsqueda...</h4>

}
